import { lazyLoadSearchTable } from 'owa-mail-execute-search-actions';
import { searchSessionStarted } from 'owa-search';
import { orchestrator } from 'satcheljs';
import { onSearchSessionStarted } from 'owa-search-next-lazy';

orchestrator(searchSessionStarted, () => {
    /**
     * Pre-import lazy search operations needed for making requests for search
     * results, because if we do not, the first import will go through a promise
     * resolve, delaying the search request from going out, even if the script
     * file is loaded in the DOM.
     */
    lazyLoadSearchTable.import();
});

orchestrator(onSearchSessionStarted, () => {
    /**
     * Pre-import lazy search operations needed for making requests for search
     * results, because if we do not, the first import will go through a promise
     * resolve, delaying the search request from going out, even if the script
     * file is loaded in the DOM.
     */
    lazyLoadSearchTable.import();
});
